import React from "react";
import ReactDOM from "react-dom";
import 'babel-polyfill';
// import createHistory from 'history/createBrowserHistory';
import 'whatwg-fetch';
import {Provider} from 'react-redux';
import 'video-react/dist/video-react.css';
import {I18nextProvider} from 'react-i18next';
import 'antd/dist/antd.css';
// import { PersistGate } from 'redux-persist/es/integration/react';
import './styles/App.css';
import './styles/web.css';
import './styles/big_web.css';
import './styles/mobile.css';
import './font/wechat/iconfont.css';
import { BrowserRouter as Router } from "react-router-dom";


// import { Provider as ReduxProvider } from "react-redux";

import Layout from "./container/Layout";
import i18n from './themes/language/i18n';
// import configureStore from './redux/store/index';
import createStore from './redux/store/index';

// const store = createStore();

// const {store } = configureStore();
// import createStore from "./store";
//
const store = createStore( window.REDUX_DATA );
const jsx = (
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <Router>
        <Layout />
      </Router>
    </Provider>
  </I18nextProvider>
);

const app = document.getElementById( "app" );
ReactDOM.hydrate( jsx, app );
